import axios from 'axios';

const API_BASE_URL = process.env.REACT_APP_API_URL || '/api/';

const apiClient = axios.create({
  baseURL: API_BASE_URL,
});

apiClient.interceptors.request.use(
  (config) => {
    const token = localStorage.getItem('adminToken');
    if (token) {
      config.headers['Authorization'] = `Bearer ${token}`;
    }
    return config;
  },
  (error) => Promise.reject(error)
);

apiClient.interceptors.response.use(
  (response) => response,
  (error) => {
    if (error.response && error.response.status === 401) {
      // Token inválido o expirado
      localStorage.removeItem('adminToken');
      localStorage.removeItem('isAdminLoggedIn');
      window.location.href = '/login';
    }
    return Promise.reject(error);
  }
);

export default apiClient;
